import React, { useEffect, useRef, useState } from 'react'
import { Icon } from 'rsuite'
import Chatbot from '../../resources/images/chatbot-image.png'

const CHAT_URL = 'https://chatassist-resource.thaihealth.or.th/project-management/welcome'

const ThaiHealthChat = ({ user }) => {
  const [open, setOpen] = useState(false)
  const iframeRef = useRef(null)

  // ส่งข้อมูล User เข้า iframe
  useEffect(() => {
    if (!open || !iframeRef.current) {
      return
    }

    const sendUserInfo = () => {
      iframeRef.current.contentWindow.postMessage(
        // {
        //   type: 'EGRAFTING_USER_INFO',
        //   payload: {
        //     userId: user.id,
        //     username: user.username,
        //     displayName: user.displayName,
        //   },
        // },
        'https://chatassist-resource.thaihealth.or.th'
      )
    }

    // iframe อาจโหลดไม่เสร็จตอน React render
    iframeRef.current.addEventListener('load', sendUserInfo)

    return () => {
      iframeRef.current?.removeEventListener('load', sendUserInfo)
    }
  }, [open, user])

  const toggleChat = () => {
    setOpen((prev) => !prev)
  }

  return (
    <>
      {/* Chat Window */}
      {open && (
        <div
          className="chatbot-chat-color"
          style={{
            position: 'fixed',
            right: 20,
            bottom: 30,
            // bottom: 85,
            width: 420,
            height: 650,
            // backgroundColor: '#fff',
            borderRadius: 12,
            boxShadow: '0 4px 25px rgba(0,0,0,0.25)',
            overflow: 'hidden',
            zIndex: 99,
            transition: 'all 0.2s ease',
          }}
        >
          {/* Header */}
          <div
            className="chatbot-color"
            style={{
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 12px',
              // backgroundColor: '#2da888',
              // color: '#fff',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <img
                src={Chatbot}
                alt=""
                style={{
                  width: 32,
                  height: 32,
                  objectFit: 'contain',
                }}
              />
              <span>ผู้ช่วยสุขภาพอัจฉริยะ ยินดีให้บริการ</span>
            </div>

            <div>
              {/* Close */}
              <button type="button" onClick={() => setOpen(false)} style={buttonStyle}>
                <Icon icon="close" />
              </button>
            </div>
          </div>

          {/* Iframe */}
          <iframe
            ref={iframeRef}
            src={CHAT_URL}
            title="ThaiHealth Chat"
            style={{
              width: '100%',
              height: 'calc(100% - 50px)',
              border: 'none',
            }}
            allow="microphone"
          />
        </div>
      )}

      {/* Floating Button */}
      {!open && (
        <button
          type="button"
          onClick={toggleChat}
          className="chatbot-color"
          style={{
            position: 'fixed',
            right: 20,
            bottom: 30,
            // left: 70,
            // bottom: 80,
            width: 55,
            height: 55,
            borderRadius: '50%',
            border: 'none',
            // backgroundColor: '#2da888',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0,0,0,0.25)',
            zIndex: 99,
          }}
        >
          {!open ? (
            <img
              src={Chatbot}
              alt="Open ThaiHealth Chat"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          ) : (
            <span style={{ fontSize: 24 }}>×</span>
          )}
          {/* <Icon icon={open ? 'close' : 'comments'} /> */}
        </button>
      )}
    </>
  )
}

const buttonStyle = {
  background: 'transparent',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  fontSize: 16,
  marginLeft: 8,
}

export default ThaiHealthChat
